import request from '@/utils/request'

const api_prefix = '/index'

// 获取新闻列表 type: 1=市场动态 2=通知公告
export function getNewsList(params) {
    return request({
        url: api_prefix + '/getnewslist',
        method: 'get',
        params
    })
}

// 获取新闻详情
export function getNewsDetail(id) {
    return request({
        url: api_prefix + '/getnewsdetail',
        method: 'get',
        params: { id }
    })
}
